import React from "react";

function Spacer(props) {
  return (
    <div style={{ marginTop: props.margin, marginBottom: props.margin }}></div>
  );
}

export default Spacer;
